<div class="kid-verify">
  @switch (step()) {
    @case ('intro') {
      <section class="kid-verify__card">
        <h2 class="kid-verify__title">
          {{ 'app.identity.kidVerify.intro.title' | translate }}
        </h2>
        <p class="kid-verify__copy">
          {{ 'app.identity.kidVerify.intro.body' | translate }}
        </p>
        <ul class="kid-verify__list">
          <li>{{ 'app.identity.kidVerify.intro.point1' | translate }}</li>
          <li>{{ 'app.identity.kidVerify.intro.point2' | translate }}</li>
          <li>{{ 'app.identity.kidVerify.intro.point3' | translate }}</li>
        </ul>
        <div class="kid-verify__actions">
          <app-parent-button
            variant="primary"
            [fullWidth]="true"
            [loading]="isBusy()"
            (clicked)="startVerification()"
          >
            {{ 'app.identity.kidVerify.intro.cta' | translate }}
          </app-parent-button>
        </div>
      </section>
    }

    @case ('consent') {
      <section class="kid-verify__card">
        <app-identity-consent-card
          titleKey="app.identity.kidVerify.consent.title"
          bodyKey="app.identity.kidVerify.consent.body"
          leadLabelKey="app.identity.kidVerify.consent.lead"
          [pointKeys]="[
            'app.identity.kidVerify.consent.point1',
            'app.identity.kidVerify.consent.point2',
            'app.identity.kidVerify.consent.point3'
          ]"
          noteKey="app.identity.kidVerify.consent.note"
          checkboxLabelKey="app.identity.kidVerify.consent.checkbox"
          backLabelKey="app.identity.kidVerify.back"
          continueLabelKey="app.identity.kidVerify.continue"
          panelAriaLabel="Guardian consent details"
          leadIconSrc="/public/svgs/add-kid.svg"
          [busy]="isBusy()"
          [(checked)]="consentAccepted"
          (back)="goBack()"
          (continue)="goToDocumentType()"
        />
      </section>
    }

    @case ('documentType') {
      <section class="kid-verify__card">
        <h2 class="kid-verify__title">
          {{ 'app.identity.kidVerify.documentType.title' | translate }}
        </h2>
        <div class="kid-verify__segment">
          <button
            type="button"
            class="kid-verify__segment-btn"
            [class.kid-verify__segment-btn--active]="documentType() === 'birth_certificate'"
            (click)="selectDocumentType('birth_certificate')"
          >
            {{ 'app.identity.kidVerify.documentType.birthCertificate' | translate }}
          </button>
          <button
            type="button"
            class="kid-verify__segment-btn"
            [class.kid-verify__segment-btn--active]="documentType() === 'passport'"
            (click)="selectDocumentType('passport')"
          >
            {{ 'app.identity.kidVerify.documentType.passport' | translate }}
          </button>
          <button
            type="button"
            class="kid-verify__segment-btn"
            [class.kid-verify__segment-btn--active]="documentType() === 'id_card'"
            (click)="selectDocumentType('id_card')"
          >
            {{ 'app.identity.kidVerify.documentType.idCard' | translate }}
          </button>
        </div>
        <div class="kid-verify__actions">
          <app-parent-button variant="ghost" (clicked)="goBack()">
            {{ 'app.identity.kidVerify.back' | translate }}
          </app-parent-button>
        </div>
      </section>
    }

    @case ('documentFront') {
      <section class="kid-verify__card">
        <h2 class="kid-verify__title">
          {{ 'app.identity.kidVerify.documentFront.title' | translate }}
        </h2>
        <div class="kid-verify__capture">
          <span>{{ 'app.identity.kidVerify.captureHint' | translate }}</span>
        </div>
        <div class="kid-verify__actions">
          <app-parent-button variant="ghost" (clicked)="goBack()">
            {{ 'app.identity.kidVerify.back' | translate }}
          </app-parent-button>
          <app-parent-button variant="primary" (clicked)="nextFromDocumentFront()">
            {{ 'app.identity.kidVerify.capture' | translate }}
          </app-parent-button>
        </div>
      </section>
    }

    @case ('documentBack') {
      <section class="kid-verify__card">
        <h2 class="kid-verify__title">
          {{ 'app.identity.kidVerify.documentBack.title' | translate }}
        </h2>
        <div class="kid-verify__capture">
          <span>{{ 'app.identity.kidVerify.captureHint' | translate }}</span>
        </div>
        <div class="kid-verify__actions">
          <app-parent-button variant="ghost" (clicked)="goBack()">
            {{ 'app.identity.kidVerify.back' | translate }}
          </app-parent-button>
          <app-parent-button variant="primary" (clicked)="nextFromDocumentBack()">
            {{ 'app.identity.kidVerify.capture' | translate }}
          </app-parent-button>
        </div>
      </section>
    }

    @case ('selfie') {
      <section class="kid-verify__card">
        <h2 class="kid-verify__title">
          {{ 'app.identity.kidVerify.selfie.title' | translate }}
        </h2>
        <p class="kid-verify__copy">
          {{ 'app.identity.kidVerify.selfie.body' | translate }}
        </p>
        <div class="kid-verify__capture kid-verify__capture--round">
          <span>{{ 'app.identity.kidVerify.selfie.hint' | translate }}</span>
        </div>
        @if (showSimulate()) {
          <label class="kid-verify__consent kid-verify__consent--dev">
            <input
              type="checkbox"
              [checked]="simulateFailed()"
              (change)="simulateFailed.set($any($event.target).checked)"
            />
            <span>{{ 'app.identity.kidVerify.devSimulateFail' | translate }}</span>
          </label>
        }
        <div class="kid-verify__actions">
          <app-parent-button variant="ghost" (clicked)="goBack()">
            {{ 'app.identity.kidVerify.back' | translate }}
          </app-parent-button>
          <app-parent-button
            variant="primary"
            [loading]="isBusy()"
            (clicked)="completeCapture()"
          >
            {{ 'app.identity.kidVerify.submit' | translate }}
          </app-parent-button>
        </div>
      </section>
    }

    @case ('processing') {
      <section class="kid-verify__card kid-verify__card--center">
        <span class="kid-verify__spinner" aria-hidden="true"></span>
        <h2 class="kid-verify__title">
          {{ 'app.identity.kidVerify.processing.title' | translate }}
        </h2>
        <p class="kid-verify__copy">
          {{ 'app.identity.kidVerify.processing.body' | translate }}
        </p>
      </section>
    }

    @case ('result') {
      <section class="kid-verify__card kid-verify__card--center">
        @if (!verificationFailed()) {
          <div class="kid-verify__status kid-verify__status--success" aria-hidden="true">✓</div>
          <h2 class="kid-verify__title">
            {{ 'app.identity.kidVerify.result.successTitle' | translate }}
          </h2>
          <p class="kid-verify__copy">
            {{ 'app.identity.kidVerify.result.successBody' | translate }}
          </p>
        } @else {
          <div class="kid-verify__status kid-verify__status--error" aria-hidden="true">!</div>
          <h2 class="kid-verify__title">
            {{ 'app.identity.kidVerify.result.failedTitle' | translate }}
          </h2>
          <p class="kid-verify__copy">
            {{ 'app.identity.kidVerify.result.failedBody' | translate }}
          </p>
          <div class="kid-verify__actions">
            <app-parent-button
              variant="primary"
              [fullWidth]="true"
              [loading]="isBusy()"
              (clicked)="retry()"
            >
              {{ 'app.identity.kidVerify.result.retry' | translate }}
            </app-parent-button>
          </div>
        }
      </section>
    }
  }
</div>
